import { createFileRoute } from '@tanstack/react-router';
import { DocsIndexComponent } from '~/modules/docs/page-route-components';
import { docsConfig, ensureDocPageComponent } from '~/modules/page/content';
import { createErrorComponent, createNotFoundComponent } from '~/routes/-route-utils';
import { pageHead } from '~/utils/app-title';

export const Route = createFileRoute('/_public/_content/docs/')({
  staticData: { isAuth: false },
  head: () => pageHead(docsConfig.title, docsConfig.description),
  // Resolve the code-split intro body before rendering (same rationale as page.$.tsx).
  loader: async () => {
    await ensureDocPageComponent('');
  },
  errorComponent: createErrorComponent('public', '/docs'),
  notFoundComponent: createNotFoundComponent('public', '/docs'),
  component: DocsIndexComponent,
});
